import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { px, mt, mb, my } from 'styled-components-spacing';
import { colors, Text } from 'themes/components';

const StyledHeading = styled(Text)`
  text-align: center;
  color: ${colors.grey30};
  ${mt({ mobile: 3, tablet: 6, desktop: 10 })};
  ${mb(1)};
`;

const Logos = styled.div`
  display: flex;
  justify-content: center;
  ${px(2)};
  ${mt(4)};
  ${mb(8)};
`;

const TrustedBy = () => (
  <>
    <StyledHeading variant="large">Trusted by teams at</StyledHeading>
    <Logos>
      <StaticImage
        src="./images/logos.png"
        alt="Logos of companies using mudstack."
        loading="lazy"
        width={750}
      />
    </Logos>
  </>
);

export default TrustedBy;
